export default __webpack_public_path__ + "static/media/error.7bbe742c.svg";